// src/pages/ScheduleConsultation.jsx
import React, { useState } from 'react';
import axios from 'axios';

export default function ScheduleConsultation() {
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    commonname: '',
    email: '',
    phone: '',
    address: '',
    landmark: '',
    preferredDate: '',
    serviceType: 'general',
    message: '',
    apiType: 'scheduleConsultation'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      //await axios.post('/api/consultations', formData);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData }
      );
      console.log("What Am Getting From The Backend = ", response.data)
      //alert('Consultation scheduled successfully!');
    } catch (error) {
      console.error('Error scheduling consultation:', error);
    }
  };

  return (
    <div className="container my-5">
      <h1 className="text-center mb-5">Schedule a Consultation</h1>
      
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="card shadow-lg">
            <div className="card-body p-5">
              <form onSubmit={handleSubmit}>
              <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Last Name</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      required
                      value={formData.lname}
                      onChange={(e) => setFormData({...formData, lname: e.target.value})}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">First Name</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      required
                      value={formData.fname}
                      onChange={(e) => setFormData({...formData, fname: e.target.value})}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Name You Are Commonly Refered To</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    required
                    value={formData.commonname}
                    onChange={(e) => setFormData({...formData, commonname: e.target.value})}
                  />
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Email Address</label>
                    <input 
                      type="email" 
                      className="form-control" 
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Phone Number</label>
                    <input 
                      type="tel" 
                      className="form-control" 
                      required
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    />
                  </div>
                </div>

            <div className="row g-3 mt-3">
                  <div className="col-md-6">
                    <label className="form-label">Preferred Date</label>
                    <input 
                      type="date" 
                      className="form-control" 
                      required
                      value={formData.preferredDate}
                      onChange={(e) => setFormData({...formData, preferredDate: e.target.value})}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Service Type</label>
                    <select 
                      className="form-select border-bottom border-light py-2 w-100"
                      value={formData.serviceType}
                      onChange={(e) => setFormData({...formData, serviceType: e.target.value})}
                    >
                      <option value="general">General Consultation</option>
                      <option value="preconception">Preconception</option>
                      <option value="antenatal">Antenatal Care</option>
                      <option value="postnatal">Postnatal Care</option>
                    </select>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Physical Address</label>
                    <textarea 
                      type="text" 
                      className="form-control"
                      rows="4"
                      required
                      value={formData.address}
                      onChange={(e) => setFormData({...formData, address: e.target.value})}
                    ></textarea>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Notable Landmark</label>
                    <textarea 
                      type="text" 
                      className="form-control" 
                      rows="4"
                      required
                      value={formData.landmark}
                      onChange={(e) => setFormData({...formData, landmark: e.target.value})}
                    ></textarea>
                  </div>
                </div>

                <div className="mb-3 mt-3">
                  <label className="form-label">Message</label>
                  <textarea 
                    className="form-control" 
                    rows="4"
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-lg w-100">
                  Schedule Consultation
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}